import { gql } from "@apollo/client";
import { EVENT_FIELDS, USER_FIELDS } from "./fragments";

const GET_USERS = gql`
  query GetUsers {
    user {
      ...UserFields
    }
  }
  ${USER_FIELDS}
`;

const GET_EVENTS = gql`
  query GetEvents {
    events {
      ...EventFields
    }
  }
  ${EVENT_FIELDS}
`;

const GET_EVENT_BY_URL = gql`
  query GetEventByUrl($eventUrl: String!) {
    eventByUrl(url: $eventUrl) {
      ...EventFields
    }
  }
  ${EVENT_FIELDS}
`;

export { GET_USERS, GET_EVENTS, GET_EVENT_BY_URL };
